<template><div></div></template>

<script>
export default {
  name: 'cyber-guard-a1',
  created() {
    window.location.href = 'https://cyberguard2024.hr/en.html'
  },
}
</script>
